import { formatDateDisplay } from 'Data/format'

export function getText(activeTab) {
  return `We acknowledge that we have received a payment of $${
    activeTab.data.downpayment
  } from ${activeTab.name} on ${formatDateDisplay(
    new Date()
  )}. The payment was done via cash.`
}
